import React from 'react';
import Login from '../Components/Login/Login';

export default function LoginPage() {
  return (
    <div>
      <Login />
    </div>
  );
}
